import script from "./PracticeRace.vue?vue&type=script&setup=true&lang=js"
export * from "./PracticeRace.vue?vue&type=script&setup=true&lang=js"

import "./PracticeRace.vue?vue&type=style&index=0&id=3ddde3c2&lang=css"

const __exports__ = script;

export default __exports__